module.exports = __webpack_public_path__ + "static/media/Icons-20x20-Dropdown-Dropdown 2_left_Light Blue_disabled.601b5c91.svg";